var map = {
	"./arrow-return.svg": 85,
	"./questions/question-example.jpg": 313,
	"./quiz/quizEco2/quiz2/1.png": 118,
	"./quiz/quizEco2/quiz2/2.png": 119,
	"./quiz/quizEco2/quiz2/3.png": 120,
	"./quiz/quizEco2/quiz2/4.png": 121,
	"./quiz/quizEco2/quiz2/5.png": 122,
	"./quiz/quizEco2/quiz2/6.png": 123,
	"./quiz/quizEco2/quiz20/1.png": 124,
	"./quiz/quizEco2/quiz20/2.png": 125,
	"./quiz/quizEco2/quiz20/3.png": 126,
	"./quiz/quizEco2/quiz21/1.png": 127,
	"./quiz/quizEco2/quiz25/1.png": 128,
	"./quiz/quizEco2/quiz25/2.png": 129,
	"./quiz/quizEco2/quiz26/1.png": 130,
	"./quiz/quizEco2/quiz26/2.png": 131,
	"./quiz/quizEco2/quiz26/3.png": 132,
	"./quiz/quizEco2/quiz27/1.png": 133,
	"./quiz/quizEco2/quiz27/2.png": 134,
	"./quiz/quizEco2/quiz28/1.png": 135,
	"./quiz/quizEco2/quiz28/2.png": 136,
	"./quiz/quizEco2/quiz3/1.png": 137,
	"./quiz/quizEco2/quiz3/2.png": 138,
	"./quiz/quizEco2/quiz3/3.png": 139,
	"./quiz/quizEco2/quiz4/1.png": 140,
	"./quiz/quizEco2/quiz4/2.png": 141,
	"./quiz/quizEco2/quiz4/3.png": 142,
	"./quiz/quizEco3E/quiz1/1.png": 143,
	"./quiz/quizEco3E/quiz10/1.png": 144,
	"./quiz/quizEco3E/quiz12/1.png": 145,
	"./quiz/quizEco3E/quiz13/1.png": 146,
	"./quiz/quizEco3E/quiz14/1.png": 147,
	"./quiz/quizEco3E/quiz14/2.png": 148,
	"./quiz/quizEco3E/quiz15/1.png": 149,
	"./quiz/quizEco3E/quiz15/2.png": 150,
	"./quiz/quizEco3E/quiz16/1.png": 151,
	"./quiz/quizEco3E/quiz17/1.png": 152,
	"./quiz/quizEco3E/quiz17/2.png": 153,
	"./quiz/quizEco3E/quiz18/1.png": 154,
	"./quiz/quizEco3E/quiz18/2.png": 155,
	"./quiz/quizEco3E/quiz19/1.png": 156,
	"./quiz/quizEco3E/quiz19/2.png": 157,
	"./quiz/quizEco3E/quiz2/1.png": 158,
	"./quiz/quizEco3E/quiz2/2.png": 159,
	"./quiz/quizEco3E/quiz20/1.png": 160,
	"./quiz/quizEco3E/quiz21/1.png": 161,
	"./quiz/quizEco3E/quiz21/2.png": 162,
	"./quiz/quizEco3E/quiz22/1.png": 163,
	"./quiz/quizEco3E/quiz22/2.png": 164,
	"./quiz/quizEco3E/quiz23/1.png": 165,
	"./quiz/quizEco3E/quiz23/2.png": 166,
	"./quiz/quizEco3E/quiz23/3.png": 167,
	"./quiz/quizEco3E/quiz3/1.png": 168,
	"./quiz/quizEco3E/quiz3/2.png": 169,
	"./quiz/quizEco3E/quiz4/1.png": 170,
	"./quiz/quizEco3E/quiz4/2.png": 171,
	"./quiz/quizEco3E/quiz5/1.png": 172,
	"./quiz/quizEco3E/quiz5/2.png": 173,
	"./quiz/quizEco3E/quiz6/1.png": 174,
	"./quiz/quizEco3E/quiz7/1.png": 175,
	"./quiz/quizEco3E/quiz7/2.png": 176,
	"./quiz/quizEco3E/quiz8/1.png": 177,
	"./quiz/quizEco3E/quiz8/2.png": 178,
	"./quiz/quizEco3E/quiz9/1.png": 179,
	"./quiz/quizEco3E/quiz9/2.png": 180,
	"./quiz/quizEco4NE/quiz3/1.png": 181,
	"./quiz/quizEco4NE/quiz3/2.png": 182,
	"./quiz/quizEco4NE/quiz3/3.png": 183,
	"./quiz/quizEco4NE/quiz4/1.png": 184,
	"./quiz/quizEco4NE/quiz4/2.png": 185,
	"./quiz/quizEco4NE/quiz5/1.png": 186,
	"./quiz/quizEco4NE/quiz5/2.png": 187,
	"./quiz/quizEco4NE/quiz6/1.png": 188,
	"./quiz/quizEco4NE/quiz6/2.png": 189,
	"./quiz/quizEco4NE/quiz6/3.png": 190,
	"./quiz/quizEstadistica2/quiz1/1.png": 191,
	"./quiz/quizEstadistica2/quiz1/2.png": 192,
	"./quiz/quizEstadistica2/quiz1/3.png": 193,
	"./quiz/quizEstadistica2/quiz2/1.png": 194,
	"./quiz/quizEstadistica2/quiz2/2.png": 195,
	"./quiz/quizEstadistica2/quiz2/3.png": 196,
	"./quiz/quizEstadistica2/quiz3/1.png": 197,
	"./quiz/quizEstadistica2/quiz3/2.png": 198,
	"./quiz/quizEstadistica2/quiz3/3.png": 199,
	"./quiz/quizEstadistica2/quiz4/1.png": 200,
	"./quiz/quizEstadistica2/quiz4/2.png": 201,
	"./quiz/quizEstadistica2/quiz4/3.png": 202,
	"./quiz/quizEstadistica2/quiz5/1.png": 203,
	"./quiz/quizEstadistica2/quiz5/2.png": 204,
	"./quiz/quizEstadistica2/quiz5/3.png": 205,
	"./quiz/quizEstadistica2/quiz6/1.png": 206,
	"./quiz/quizEstadistica2/quiz6/2.png": 207,
	"./quiz/quizEstadistica2/quiz6/3.png": 208,
	"./quiz/quizInferencia/quiz1/1.png": 209,
	"./quiz/quizInferencia/quiz1/2.png": 210,
	"./quiz/quizInferencia/quiz1/3.png": 211,
	"./quiz/quizInferencia/quiz2/1.png": 212,
	"./quiz/quizInferencia/quiz2/2.png": 213,
	"./quiz/quizInferencia/quiz2/3.png": 214,
	"./quiz/quizInferencia/quiz3/1.png": 215,
	"./quiz/quizInferencia/quiz3/2.png": 216,
	"./quiz/quizInferencia/quiz3/3.png": 217,
	"./quiz/quizInferencia/quiz4/1.png": 218,
	"./quiz/quizInferencia/quiz4/2.png": 219,
	"./quiz/quizInferencia/quiz4/3.png": 220,
	"./quiz/quizInferencia/quiz5/1.png": 221,
	"./quiz/quizInferencia/quiz5/2.png": 222,
	"./quiz/quizInferencia/quiz5/3.png": 223,
	"./quiz/quizInferencia/quiz6/1.png": 224,
	"./quiz/quizInferencia/quiz6/2.png": 225,
	"./quiz/quizInferencia/quiz6/3.png": 226,
	"./results/default/default.jpg": 227,
	"./results/result-example.jpg": 228,
	"./start/start-example.jpg": 314,
	"./test.png": 315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;